import { render } from "./Cargo.vue?vue&type=template&id=339d7862&scoped=true"
import script from "./Cargo.vue?vue&type=script&lang=js"
export * from "./Cargo.vue?vue&type=script&lang=js"

import "./Cargo.vue?vue&type=style&index=0&id=339d7862&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-339d7862"]])

export default __exports__